import { Box, Button, Grid, Typography } from '@mui/material';
import { Slider } from '../../../../types/slider';
import { sliderStyles } from './styles';
import { Link } from 'react-router-dom';

interface SliderItemProps {
  slider: Slider;
}
export const SliderItem: React.FC<SliderItemProps> = ({ slider }) => {
  const isSameOrigin = slider.link ? slider.link.startsWith(window.location.origin) : false;
  const resolvedLink = isSameOrigin ? slider.link?.replace(window.location.origin, '') : slider.link;

  return (
    <Box>
      <Grid
        container
        justifyContent="space-between"
        direction={{ xs: 'column-reverse', md: 'row' }}
        alignItems={{ md: 'center' }}
        spacing={2.5}
      >
        <Grid item xs={12} md={6} xl={5}>
          <Box sx={sliderStyles.contentContainer}>
            {slider.heading && (
              <Typography sx={{ mb: 4 }} variant="h3" component="h1">
                {slider.heading}
              </Typography>
            )}
            <Typography sx={sliderStyles.detail} paragraph variant="medium" color="secondary">
              {slider.text_over}
            </Typography>
            {slider.link && slider.button_text && (
              <Box sx={{ mt: 6 }}>
                <Button
                  component={isSameOrigin ? Link : 'a'}
                  to={resolvedLink}
                  href={slider.link}
                  variant="contained"
                  color="primary"
                >
                  {slider.button_text}
                </Button>
              </Box>
            )}
          </Box>
        </Grid>
        {slider.media && (
          <Grid item xs={12} md={6} lg={5} xl={4}>
            <Box sx={sliderStyles.imageContainer}>
              <Box
                component="img"
                sx={sliderStyles.image}
                src={slider.media}
                alt={slider.slider_picture.alt_text || ''}
              />
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
